import { render } from "./DGII.vue?vue&type=template&id=36ac02a2"
import script from "./DGII.vue?vue&type=script&lang=js"
export * from "./DGII.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__